export default __webpack_public_path__ + "static/media/503.08144e7a.png";